import { isNullOrUndefined } from 'util';
import { Injectable } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { FieldConfig, ChildAoeDto } from 'src/app/core/interfaces/field-config';

@Injectable({
  providedIn: 'root'
})
export class DynamicFormServiceService {

  regConfig: FieldConfig[];
  mappedDataRecur: FieldConfig[] = [];
  constructor() { }

  checkHasRequired(field: any): boolean {
    const validations = field.validations;
    if (validations != null && validations.length > 0) {
      for ( const validator of validations) {
        if (validator.name === 'required') {
          return true;
        }
      }
    }
    return false;
  }

  mappingData(field: FieldConfig[]): FieldConfig[] {
    this.mappedDataRecur = [];
    const childAOECollection = field.filter((x) => x.isChildAoe);
    const withOutChildAOECollection: FieldConfig[] = field.filter((x) => !x.isChildAoe);
    for (const key of withOutChildAOECollection) {
      if (key.childAoeDtos && key.childAoeDtos.length > 0) {
        const parentObject = key;
        const parentLabelCode = parentObject.labelCode + '::' + parentObject.version;
        parentObject.labelCode = parentLabelCode;
        this.mappedDataRecur.push(parentObject);
        this.addChildAORRecur(key, childAOECollection);
      } else {
        const parentLabelCode = key.labelCode + '::' + key.version;
        key.labelCode = parentLabelCode;
        this.mappedDataRecur.push(key);
      }
    }
    return this.mappedDataRecur;
  }

  private addChildAORRecur(field: FieldConfig, childAOECollection) {
    for (const key of field.childAoeDtos) {
      const childAOEDto: ChildAoeDto = key;
      const childAOEIndex = childAOECollection.findIndex((x) => x.labelCode === childAOEDto.lableCode);
      if (childAOEIndex > -1) {
        const childAOEFound: FieldConfig = Object.assign({}, childAOECollection[childAOEIndex]);
        childAOEFound.labelCode = field.labelCode + '::' + childAOEFound.labelCode + '::' + childAOEFound.version;
        const index = this.mappedDataRecur.findIndex(x => x.labelCode === childAOEFound.labelCode);
        if (index === -1) {
          this.mappedDataRecur.push(childAOEFound);
          if (childAOEFound.childAoeDtos && childAOEFound.childAoeDtos.length > 0) {
            this.addChildAORRecur(childAOEFound, childAOECollection);
          }
        }
      }
    }
    return this.mappedDataRecur;
  }


  revealChildLabelCodes(childAoe: ChildAoeDto[], value, parentLabelCode) {
    const labelCodes = [];
    for (const key of childAoe) {
      if (key.enumOptionCode === value) {
        labelCodes.push(parentLabelCode + '::' + key.lableCode + '::' + key.version);
      }
    }
    return (!isNullOrUndefined(labelCodes) && labelCodes.length > 0) ? labelCodes : -1;
  }

  getAllChildAOEcodeFomParent(field: FieldConfig) {
    const labelCodes = [];
    for (const key of field.childAoeDtos) {
      labelCodes.push(field.labelCode + '::' + key.lableCode + '::' + key.version);
    }
    labelCodes.push(...this.checkChildHasChilds(labelCodes));
    return labelCodes;
  }

  checkChildHasChilds(labelCode) {
    const labelCodes = [];
    for (const key of labelCode) {
      const splitkeys = key.split('::');
      const childParam = splitkeys[splitkeys.length - 2];
      let filteredList: any = this.regConfig.filter((x) =>
        x.labelCode.includes(childParam));
      filteredList = filteredList.map((x) => x.labelCode);
      labelCodes.push(...filteredList);
    }
    return labelCodes;
  }

  setRegConfig(value: FieldConfig[]) {
    this.regConfig = value;
  }

  getRegConfig() {
    return this.regConfig;
  }

  isControlExist(dynamicForm, ctrlName: string) {
    if (!ctrlName) {
      return false;
    }
    const ctrl = dynamicForm.get(ctrlName) as UntypedFormControl;
    return ctrl ? true : false;
  }
}
